import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import useCheckboxes from "../../Hooks/useCheckboxes";
import HighSchoolGraduationTypeService from "../../../Services/HighSchoolGraduationType.service";
const PAGE_SIZE = 15;
const SEARCH_DEFAULT = "";
const DEFAULT_SEARCH = {
    search: SEARCH_DEFAULT,
};
const HighSchoolGraduationTypeLookup = ({ selected: selectedHighSchoolGraduationTypes, children, }) => {
    var _a;
    const [search, setSearch] = React.useState(SEARCH_DEFAULT);
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedHighSchoolGraduationTypes || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const searchItems = () => {
        setSearchArgs({
            search,
        });
    };
    const { table, dataState } = usePagedSortedTable({
        searchArgs,
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            getCheckedItem: (data, index) => data.data[index],
        },
        getNumPages: (result) => 
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'PagedResult<any>'.
        TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No Graduation Types found",
        initialSort: { sort: "name", order: "asc" },
        getData: (sort, page, sArgs) => {
            return HighSchoolGraduationTypeService.search({
                query: sArgs.search,
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                offset: page * PAGE_SIZE,
                max: PAGE_SIZE,
            });
        },
        columns: [
            {
                title: "Name",
                sortId: "highschoolgraduationtypename",
            },
            {
                title: "Source System Id",
                sortId: "highschoolgraduationtypesrcsystemid",
            },
        ],
        // @ts-expect-error - TS2322 - Type '({ data }: { data: any; }) => any' is not assignable to type 'Node[][] & ((arg1: unknown) => Node[][])'.
        rows: ({ data }) => 
        // @ts-expect-error - TS7006 - Parameter 'highSchoolGraduationType' implicitly has an 'any' type.
        data.map((highSchoolGraduationType) => [
            highSchoolGraduationType.name,
            highSchoolGraduationType.srcSystemId,
        ]),
    });
    return children({
        lookup: (_jsxs(_Fragment, { children: [_jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "highSchoolGraduationTypeSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "highSchoolGraduationTypeSearch", placeholder: "Search Name, ID", style: { width: 200 }, value: search, onChange: (event) => {
                                        setSearch(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
    });
};
export default HighSchoolGraduationTypeLookup;
